export default __webpack_public_path__ + "e51a843b82aaf585a17db1caadcb9949.png";